import type { SearchType } from '../types';

export interface DeepSearchResponse {
  success: boolean;
  searchId: string;
  message: string;
}

/**
 * Initiate a deep search using OpenAI's Deep Research API
 * @param userId - The user's unique ID
 * @param query - The search query
 * @param searchType - The type of search to perform
 * @returns Response with searchId to track the search
 */
export async function initiateDeepSearch(
  userId: string,
  query: string,
  searchType: SearchType
): Promise<DeepSearchResponse> {
  const response = await fetch('/api/deep-search', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId,
      query,
      searchType,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to initiate search');
  }

  return response.json();
}
